import React from 'react';
import Skeleton from 'react-loading-skeleton';

import './AccountNameBox.scss';
import './AccountNameBoxSkeleton.scss';

const AccountNameBox: React.FC = () => {
    return (
        <div className="account-name-box__container">
            <div className="account-name-box__label">
                <Skeleton width={150} height={22} />
            </div>
            <div className="account-name-box__account_name_skeleton">
                <Skeleton width="100%" height={20} />
            </div>
        </div>
    );
};

export default AccountNameBox;
